import { IS_SAVING_CHANGES, IS_NOT_SAVING_CHANGES } from "../constants";

export const setSavingChanges = () => ({
    type: IS_SAVING_CHANGES,
});

export const notSavingChanges = () => ({
    type: IS_NOT_SAVING_CHANGES,
});
